import { createDEL as $createDEL, createGET as $createGET, createGETExFile as $createGETExFile, createPostExFile as $createPostExFile, createPATCH as $createPATCH, createPOST as $createPOST, createPOSTFormData as $createPOSTFormData, createPUT as $createPUT, createService as $createService, createPUTForm as $createPUTForm, createPOSTForm as $createPOSTForm } from "./impl/createInstance";
import httpConfig from "./impl/HttpConfig";
const { service, request } = $createService(httpConfig);
export const defaultInstance = service;
const getMethod = $createGET(request);
export const get = getMethod;

const getExFileMethod = $createGETExFile(request);
export const getExFile = getExFileMethod;

const postExFileMethod = $createPostExFile(request);
export const postExFile = postExFileMethod;

const delMethod = $createDEL(request);
export const del = delMethod;

const postMethod = $createPOST(request);
export const post = postMethod;

const postFormMethod = $createPOSTForm(request);
export const postForm = postFormMethod;

const postFileMethod = $createPOSTFormData(request);
export const postFile = postFileMethod;

const putMethod = $createPUT(request);
export const put = putMethod;

const patchMethod = $createPATCH(request);
export const patch = patchMethod;

const putFormMethod = $createPUTForm(request);
export const putForm = putFormMethod;

export const createDEL = $createDEL;
export const createGETExFile = $createGETExFile;
export const createPostExFile = $createPostExFile;
export const createGET = $createGET;
export const createPATCH = $createPATCH;
export const createPOST = $createPOST;
export const createPOSTFormData = $createPOSTFormData;
export const createPUTForm = $createPUTForm;
export const createPUT = $createPUT;
export const createService = $createService;
